import { MessageAtachment } from '@common/ts/types';
import { motion } from 'framer-motion';
import Image from '../../Image/Image';
import useImageViewerStore from '../../../store/ImageViewerStore';

function ImageMessage({ url }: MessageAtachment) {
  const { setIsViewerOpen, setCurrentImageUrl, setCurrentImageAlt } = useImageViewerStore();

  const showImagePreview = () => {
    if (!url) return;
    setCurrentImageUrl(url);
    setCurrentImageAlt('image preview');
    setIsViewerOpen(true);
  };

  return (
    <motion.div
      initial={{ opacity: 1, transform: 'scale(1)' }}
      whileHover={{ opacity: 0.8, transform: 'scale(1.01)' }}
      whileTap={{ transform: 'scale(0.9)' }}
      className="w-full h-full max-w-[400px]"
    >
      <Image src={url} alt="" className="rounded-lg cursor-zoom-in" onClick={showImagePreview} />
    </motion.div>
  );
}

export default ImageMessage;
